import { CpgRetailer } from '@features/campaigns/subdomains/cpg';
import { DonutChartOptionsProps } from '@features/campaigns/subdomains/cpg/configuration/donut-chart-options';
import {
  MIN_RETAILER_COUNT,
  retailerLabel,
} from '@features/campaigns/subdomains/cpg/domain/retailers';
import { sortBy } from '@utils/arrays';
import { formatters, ValueInput } from '@utils/formattersV2';

const MAX_RETAILERS_SHOWN = MIN_RETAILER_COUNT + 1;

const formatChartTitle = (formattedValue: string) =>
  ['Total', formattedValue].join('<br />');

export const buildProjectedIncrementalSalesChartProps = (
  retailers: Pick<CpgRetailer, 'name' | 'projectedIncrementalSales'>[],
  projectedIncrementalSales: ValueInput
): DonutChartOptionsProps => ({
  data: retailers
    .toSorted(sortBy('projectedIncrementalSales', 'desc'))
    .slice(0, MAX_RETAILERS_SHOWN)
    .map(retailer => ({
      name: retailerLabel(retailer.name),
      value: retailer.projectedIncrementalSales,
    })),
  titleText: formatChartTitle(
    formatters.currency(projectedIncrementalSales, {
      full: true,
      decimals: 0,
    })
  ),
});

export const buildTotalProjectedSalesChartProps = (
  retailers: Pick<CpgRetailer, 'name' | 'totalProjectedSales'>[],
  totalProjectedSales: ValueInput
): DonutChartOptionsProps => ({
  data: retailers
    .toSorted(sortBy('totalProjectedSales', 'desc'))
    .slice(0, MAX_RETAILERS_SHOWN)
    .map(retailer => ({
      name: retailerLabel(retailer.name),
      value: retailer.totalProjectedSales,
    })),
  titleText: formatChartTitle(
    formatters.currency(totalProjectedSales, {
      full: true,
      decimals: 0,
    })
  ),
});
